import React, {useEffect, useState, useRef} from "react";
import type {QueryMultiSimRequestModel} from "../models/QueryMultiSimRequestModel";
import { Col, message, Row} from "antd";
import "./DeviceList.css"
import {useNavigate} from "react-router-dom";
import { RightOutlined } from "@ant-design/icons";
import Watch from "../../../assets/logo/watch.png";
import {submitQueryMultiSimRequest} from "../service/SubscriptionService";
import ModalContent from "../../../constant/ModalContent";
import Indicator from "../../common/components/Indicator";
import Header from "../../../components/header/Header";


export default function DeviceList(){

    const navigate=useNavigate();
    const carrierPostData = localStorage.getItem("carrierPostData");
    const sessionId= localStorage.getItem("sessionId");
    const [isLoading,setIsLoading] = useState(false);
    const isErrorMessageDisplayedRef = useRef(false);


    console.log(carrierPostData);

    const [mainUser, setMainUser] = useState({});
    const [attachUsers, setAttachUsers] = useState([]);
    const isMountedRef = useRef(false);

    const getUniqueId = () => {
        const min = 0;
        const max = 100;
        const rand = Math.floor(Math.random() * (max - min + 1) + min);
        console.log(rand);
        return rand;
    };

    const fetchMultiSimQuery=async () => {
        setIsLoading(true);
        try {
            const queryMultiSimRequest: QueryMultiSimRequestModel = {
                sessionId: sessionId,
                "request-id": getUniqueId(),
                carrierPostData: carrierPostData,
            }
            const response = await submitQueryMultiSimRequest(queryMultiSimRequest);
            setIsLoading(false);
            if (response.resultCode === 6000) {
                const {mainUser, attachUsers} = response;
                setMainUser(response.mainUser);
                if (response.attachUsers) {
                    setAttachUsers(response.attachUsers);
                    console.log(attachUsers);
                } else {
                    console.log("attachUsers is null");
                }
                console.log(mainUser);
            }else if (response.resultCode === 6403){
                navigate("/");
                message.error(response.resultDesc,1)
            } else {
                console.log(response);
                message.error(response.resultDesc,1)
            }
        } catch (error) {
            setIsLoading(false);
            if (!isErrorMessageDisplayedRef.current) {
                message.error(ModalContent.GENERAL_ERROR_DESCRIPTION, 1);
                isErrorMessageDisplayedRef.current = true;
            }
            throw new Error(error);
        }
    }

    useEffect(() => {
        fetchMultiSimQuery();

        // if (!isMountedRef.current) {
        //     isMountedRef.current = true;
        //     const payload = {
        //         level: "INFO",
        //         timestamp: new Date().toISOString(),
        //         pageName: LogContent.DEVICE_LIST_PAGE,
        //         message: LogContent.DEVICE_LIST_PAGE_MESSAGE
        //     };
        //
        //     submitWebSheetLogCollection(payload)
        //         .then(() => {
        //             console.log('Log submitted successfully');
        //         })
        //         .catch(error => {
        //             console.error('Error submitting log:', error);
        //         });
        // }

    }, []);

    const attachedUserRows = attachUsers ? attachUsers.map((user, index) => (
            <Row key={user.eid} className="device-row">
                <Col className="watch-col" span={3}>
                    <img src={Watch} alt="Apple Watch" className="appleWatchPic" />
                </Col>
                <Col className="status-col" span={19}>
                    <b>Dialog</b>
                    <br/>
                    <span style={{color: user.status === "Active" ? "green" : "#ada6a6"}}> {user.status}</span>
                </Col>
                <Col className="arrow-col" span={2}>
                        <RightOutlined
                            onClick={() => handleNavigate(user)}
                        />
                </Col>
            </Row>
    )):null;

    const handleNavigate = (user) => {
        const data = {
            selectedUser: user,
            mainUser: mainUser
        };
        navigate("/manage-subscription/device-list/details", { state: { data: data } });
    };

    // console.log(process.env.MAX_VALUE);

    return(
        <>
            <div style={{backgroundColor:"#E6E6E6",width:"100%"}}>
                <Header/>
            </div>

            {isLoading && <Indicator />}

            <Row className="my-row">
                <Col className="first-col" span={8}>
                    Hello!
                </Col>
                <Col className="second-col" span={12}>
                    {mainUser.msisdn}
                </Col>
            </Row>

            <div className="deviceListDiv">

                {attachUsers.length > 5 &&(
                    <div className="error1">
                        The number of devices you can add has reached the maximum limit. Below are your configured devices.
                    </div>
                )}

                {attachedUserRows}

                {attachUsers.length > 5 &&(
                    <div className="error2">
                        You would need to delete a configured device in order to add a new device.
                    </div>
                )}

            </div>

        </>
    )
}